import { memo } from "react";
import { useTranslation } from "react-i18next";

const LogoAndInstructions = memo<{ tempEmail: string | undefined }>(
  ({ tempEmail }) => {
    const { t } = useTranslation("auth");

    return (
      <div className="tw-mb-8">
        <img
          src="/logo/Logo.svg"
          alt="Logo"
          loading="lazy"
          className="tw-mx-auto tw-max-w-[150px] tw-mb-14"
        />
        <h6 className="font-primary font-primary-color tw-text-[22px] font-weight-semibold tw-leading-6">
          {t("phoneVerification.title")}
        </h6>
        <p className="tw-mt-2 tw-leading-6 font-size-sm font-gray-color font-weight-medium">
          {t("phoneVerification.subtitle")}{" "}
          <span className="tw-font-semibold tw-text-[#000]">
            {t("phoneVerification.emailDisplay", { email: tempEmail })}
          </span>
        </p>
      </div>
    );
  },
);

LogoAndInstructions.displayName = "LogoAndInstructions";

export default LogoAndInstructions;
